export default {
  title: 'Add customer',
  searchCustomers: 'Search customers',
  sendEnrollmentLink: 'Send enrollment link',
  scannerActivated: 'Use a scanner',
  scanCustomer: "Scan the customer's in-app QR code to add them to the sale.",
}
